package com.evoapps.evoshift.ui.map

/** Browsers do not let a page set the User-Agent; the tile servers see the browser's and the Referer. */
internal actual val mapTileUserAgent: String? = null
